/** Compact wait-age formatting, e.g. "45s", "12m", "1h 4m". */
export function formatWait(seconds: number): string {
  const total = Math.max(0, Math.floor(seconds));
  if (total < 60) return `${total}s`;
  const minutes = Math.floor(total / 60);
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  return `${hours}h ${minutes % 60}m`;
}

/** Whole seconds elapsed since an ISO-8601 timestamp, clamped at zero. */
export function secondsSince(isoTime: string): number {
  return Math.max(0, Math.floor((Date.now() - Date.parse(isoTime)) / 1000));
}
